import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    mensaje: ''
  });
  const [status, setStatus] = useState(null); // 'success', 'error', 'loading'

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');

    try {
      const response = await fetch('http://localhost:5001/api/contact', { // Assuming backend runs on 5001
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus('success');
        setFormData({ nombre: '', email: '', mensaje: '' }); // Clear form
      } else {
        setStatus('error');
        console.error('Error del servidor:', data.message);
      }
    } catch (error) {
      setStatus('error');
      console.error('Error de red:', error);
    }
  };

  return (
    <section id="contact" className="contact-section py-5">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">Contáctanos</h2>
          <p className="lead text-muted">Envíanos un mensaje y te responderemos a la brevedad.</p>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3" controlId="formNombre">
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Tu nombre"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="tu@email.com"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formMensaje">
                <Form.Label>Mensaje</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Escribe tu mensaje aquí"
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Button variant="primary" type="submit" disabled={status === 'loading'}>
                {status === 'loading' ? 'Enviando...' : 'Enviar Mensaje'}
              </Button>

              {status === 'success' && (
                <Alert variant="success" className="mt-3">
                  ¡Mensaje enviado con éxito! Te contactaremos pronto.
                </Alert>
              )}
              {status === 'error' && (
                <Alert variant="danger" className="mt-3">
                  Hubo un error al enviar tu mensaje. Por favor, inténtalo de nuevo más tarde.
                </Alert>
              )}
            </Form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
